import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["summary", "showcase", "destinations", "channels", "medium"]

  updateSummary() {
    const tags = this.collectTags()
    this.summaryTarget.replaceChildren(...tags.map(tag => this.buildTagPill(tag)))
  }

  buildTagPill(text) {
    const pill = document.createElement("span")
    pill.className = "bg-seasalt-300 text-darkblue ui-text-body rounded-5 pl-5 pr-8 py-1 2xl:py-3 wrap-anywhere"
    pill.textContent = text
    return pill
  }

  collectTags() {
    return [
      ...this.destinationTags(),
      ...this.channelTags(),
      ...this.mediumTags(),
      ...this.showcaseTags()
    ]
  }

  destinationTags() {
    return this.selectedValues(this.destinationsTarget).map(value => `Destination: ${value}`)
  }

  channelTags() {
    return this.selectedValues(this.channelsTarget).map(value => `Channel: ${value}`)
  }

  mediumTags() {
    const value = this.mediumTarget.value
    return value ? [`Medium: ${value}`] : []
  }

  showcaseTags() {
    if (this.hasShowcaseTarget && this.showcaseTarget.checked) {
      return ["Showcase: Yes"]
    }
    return []
  }

  selectedValues(select) {
    return Array.from(select.selectedOptions).map(option => option.value)
  }
}
